'use client';

import {refreshAccountTotalBalance} from '@/hooks';
import {usePurchaseContext} from './PurchaseProvider';
import {useEffect, useState} from 'react';
import {PostPurchaseModal} from './PostPurchaseModal';
import {PurchaseReceipt} from '@/types';

const PurchaseCompletedTrigger: React.FC = () => {
	const {state: purchaseState, ...purchaseContext} = usePurchaseContext();
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (purchaseState === 'purchaseCompleted') {
			// const {
			// 	actions: {
			// 		purchaseCompleted: { next },
			// 	},
			// } = purchaseContext as PurchaseContextProps<"purchaseCompleted">;

			Promise.allSettled([refreshAccountTotalBalance()])
				.catch((err) => console.error(err))
				.finally(() => {
					setOpen(true);
					// next();
				});
		}
	}, [purchaseContext.actions, purchaseState]);

	return (
		open &&
		purchaseState === 'purchaseCompleted' && (
			<PostPurchaseModal open {...(purchaseContext?.receipt || ({} as PurchaseReceipt))} />
		)
	);
};

export default PurchaseCompletedTrigger;
